import React, { CSSProperties, useState } from 'react'
import styled from 'styled-components'
import { theme } from 'src/Styles/theme'

const OuterContainer = styled.div`
  border-radius: 14px;
  filter: drop-shadow(0 0 0.25rem ${theme.colors.boxShadowColor});
  cursor: pointer;
  background-color: ${theme.colors.white};
  padding: 16px;

  @media (min-width: 320px) {
    flex: 1;
    min-width: 220px;
  }

  @media (min-width: 420px) {
    flex: 1;
    min-width: 320px;
  }

  @media (min-width: 500px) {
    flex: 1;
    min-width: 400px;
  }

  @media (min-width: 769px) {
    min-width: 0px;
  }
`

interface Props {
  children?: JSX.Element
  onPress?: () => void
  style?: CSSProperties
}

export const CardView = ({ children, onPress, style }: Props) => {
  const [isPressed, setIsPressed] = useState(false)
  const onTouchStart = () => {
    setIsPressed(true)
  }
  const onTouchEnd = () => {
    setIsPressed(false)
  }

  const handleKeyPress = (event: React.KeyboardEvent) => {
    // Enter or Space key
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault()
      onPress?.()
    }
  }

  return (
    <OuterContainer
      role="button"
      aria-pressed={false}
      tabIndex={onPress ? 0 : -1}
      onTouchStart={onTouchStart}
      onTouchEnd={onTouchEnd}
      onKeyPress={onPress ? handleKeyPress : () => {}}
      onClick={onPress}
      style={{
        ...style,
        opacity: isPressed && style?.pointerEvents != 'none' ? '0.5' : '1',
      }}
    >
      {children}
    </OuterContainer>
  )
}
